import Vue from 'vue'
import InfiniteLoading from 'vue-infinite-loading'

const emptyMess = 'Бесконечность не предел, но нам больше нечего показать :)'
Vue.use(InfiniteLoading, {
  slots: {
    noMore: emptyMess,
    noResults: emptyMess
  },
})
